// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import isEqual from 'lodash.isequal';

import Modal from './Modal';
import Checkbox from '../Checkbox';
import EditableMulti from '../EditableMulti';

import '../../styles/modal.css';

export default class SortingRules extends Modal {

    state = {
        enabled: false,
        match: {
            mode: "all",
            source: [],
            name: [],
            phrases: []
        }
    }

    componentDidMount = async () => this.loadRules(this.props.stack);

    componentWillReceiveProps = async (next) => {
        if (!isEqual(this.props.stack.rules, next.stack.rules))
            this.loadRules(next.stack);
    }

    loadRules = (stack) => {
        if (!stack || !stack.rules)
            return;

        this.setState({
            enabled: stack.rules.enabled,
            match: stack.rules.match
        });
    }

    saveRules = () => {
        if (this.props.stack && this.props.stack._id)
            this.props.updateStack(this.props.stack._id, {
                enabled: true,
                rules: this.state
            });
        
            this.props.modal(""); // Close
    }

    renderContent = () => {
        
        const rules = this.state;
        
        return (<div className="modal-content modal-center">

            <h1>Stack Sorting Rules</h1>

            Stax·ai bots automatically sort documents based on examples. Upload at least 5-10 example documents into each stack and the bots will sort similar incoming documents into the right stacks! However you can also set predefined sorting rules which if met, documents get sorted into the stack.

            <div style={{
                width: 350,
                margin: "0 auto",
                textAlign: "left",
                marginTop: 30
            }}>
                <Checkbox
                    label="Enable sorting into this stack based on rules"
                    checked={rules.enabled}
                    onToggle={() => this.setState({
                        enabled: !rules.enabled
                    })}
                />
            </div>

            <h2>Match document source</h2>

            <EditableMulti
                hideMenu={true}
                placeholder="Example: stax.ai, support@stax.ai ..."
                value={rules.match.source.map(pattern => ({
                    value: pattern,
                    label: pattern
                }))}
                onChange={(value) => this.setState({
                    match: {
                        ...rules.match,
                        source: value ? value.map(v => v.value) : []
                    }
                })}
            />

            <p className="modal-hint-small">
                Add email addresses, fax numbers, or domain groups to this list to automatically route all documents from them into this stack. You can also use <a href="https://regexr.com/">Regular Expressions (RegEx)</a> to match patterns.
            </p>

            <h2>Match document name or subject</h2>

            <EditableMulti
                hideMenu={true}
                placeholder="Expected document name pattern..."
                value={rules.match.name.map(pattern => ({
                    value: pattern,
                    label: pattern
                }))}
                onChange={(value) => this.setState({
                    match: {
                        ...rules.match,
                        name: value ? value.map(v => v.value) : []
                    }
                })}
            />

            <p className="modal-hint-small">
                Match text or <a href="https://regexr.com/">RegEx patterns</a> in a document name or email subject.
            </p>

            <h2>Match text content in document</h2>

            <EditableMulti
                hideMenu={true}
                placeholder="Expected text or content in document"
                value={rules.match.phrases.map(pattern => ({
                    value: pattern,
                    label: pattern
                }))}
                onChange={(value) => this.setState({
                    match: {
                        ...rules.match,
                        phrases: value ? value.map(v => v.value) : []
                    }
                })}
            />

            <p className="modal-hint-small">
                Match text in the document body (whether the document is a PDF, Word document, scan, or photo from your phone!) using words, phrases, or <a href="https://regexr.com/">RegEx patterns</a>.
            </p>

            {/* <h2>Match override mode</h2>
            <div style={{
                width: 440,
                margin: "0 auto",
                textAlign: "left"
            }}>

                <Checkbox
                    label="All rules MUST be met to sort into this stack"
                    checked={rules.match.mode === "all"}
                    onToggle={() => this.setState({
                        match: {
                            ...this.state.match,
                            mode: "all"
                        }
                    })}
                />

                <Checkbox
                    label="Any one of the rules should trigger a match"
                    checked={rules.match.mode === "any"}
                    onToggle={() => this.setState({
                        match: {
                            ...this.state.match,
                            mode: "any"
                        }
                    })}
                />

            </div> */}

            <div
                className="button"
                style={{
                    float: 'none',
                    backgroundImage: "url('https://static.stax.ai/images/icons/save.png')"
                }}
                onClick={this.saveRules}
            >Save sorting rules</div>

        </div>);
    }

};